import React from 'react';
import cx from 'classnames';

import { PERCENTAGES_COMPLETED } from '../VehicleProfilingHub/VehicleProfilingHub.constants';

import styles from './ProgressBar.module.scss';

type ProgressLineProps = {
  className?: string | Record<string, string>;
  progress?: number;
  progressLine?: boolean;
  sticky?: boolean;
}

export const ProgressLine = ({
  className, progress, progressLine = true, sticky = true,
}: ProgressLineProps) => {
  if (!progressLine) {
    return null;
  }

  const step = progress ? progress / PERCENTAGES_COMPLETED : 0;

  return (
    <div
      className={cx(styles.progressBar, className, {
        [styles.separated]: !sticky,
      })}
      style={{ '--vehicle-progress-bar-scale-x': step } as React.CSSProperties}
    >
      <div className={styles.progress} />
    </div>
  );
};
